import React, { useEffect, useState, useContext, useMemo } from 'react'
import { GlobalContext } from '../GlobalContext'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import Button from '../formfields/Button'
import YellowAlert from '../ui-elements/YellowAlert'
import FilterChecklistCategories from './FilterChecklistCategories'
import IndividualChecklist from './IndividualChecklist'
import { tab } from '@testing-library/user-event/dist/tab'

type Props = {
}

function MyChecklists({
}: Props) {

  const {
    tableData,
  } = useContext(GlobalContext)

  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [checklistIdsToDisplay, setChecklistIdsToDisplay] = useState<string[]>([])
  const numberOfChecklists = checklistIdsToDisplay.length

  useEffect(() => {
    filterChecklistCategories()
  }, [searchParams, tableData])


  const filterChecklistCategories = () => {
    if (tableData && tableData.Checklists) {
      const filters = searchParams.getAll('filter')
      //console.log(`filtering.... ${JSON.stringify(filters)}`)

      if (filters.length > 0) {
        const newChecklistIdsToDisplay: string[] = []
        Object.keys(tableData.Checklists).forEach((checklistId) => {
          const thisChecklist = tableData.Checklists[checklistId]
          const checklistCategories = thisChecklist['ChecklistCategories'] || []
          // check if any of the checklistCategories match any of the filters
          let anyMatches = false
          filters.forEach((filter) => {
            if (checklistCategories.includes(filter)) {
              anyMatches = true
            }
          })
          if (anyMatches) {
            newChecklistIdsToDisplay.push(checklistId)
          }
        })
        setChecklistIdsToDisplay(newChecklistIdsToDisplay)
      } else {
        setChecklistIdsToDisplay(Object.keys(tableData.Checklists))
      }
    } else {
      //console.log('tabledata is empty')
    }
  }



  return <div className={`flex flex-col items-center`}>
    <div className={`max-w-3xl w-full p-5 flex flex-col gap-5 items-start`}>

      <div className={`w-full flex flex-col items-start justify-between gap-3`}>
        <h3 className={`font-righteous text-3xl font-brandblue`}>My Checklists</h3>

        <div className={`w-full flex md:flex-row flex-col items-center gap-2`}>
          <Button
            internalLinkUrl={`new/settings`}
            text={`Build new checklist`}
            variant={`primary`}
            id={'buildNewChecklist'}
          />
          <Button
            internalLinkUrl={`/checklists/presets/`}
            text={`Add checklist from template`}
          />
          <Button
            internalLinkUrl={`/manage-checklist-categories`}
            text={`Manage categories`}
          />
        </div>
      </div>

      <FilterChecklistCategories />

      {numberOfChecklists === 0 && <YellowAlert>No checklists found</YellowAlert>}
      {numberOfChecklists > 0 && <p>{numberOfChecklists} checklist{numberOfChecklists === 1 ? '' : 's'} found</p>}


      <div className={`flex md:flex-row flex-col flex-wrap gap-2`}>
        {checklistIdsToDisplay.map((checklistKey, index) => {
          const thisChecklist = tableData.Checklists[checklistKey]
          return <IndividualChecklist
            key={index}
            thisChecklist={thisChecklist}
            checklistKey={checklistKey}
          />
        })}

      </div>
    </div>
  </div>

}
export default MyChecklists